import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { orderFragment } from '../lib/order/fragments/order-fragment';

export const query = gql`
  mutation CompleteGameOrder(
    $orderId: PositiveInt!
    $payAmount: Int!
    $timeZone: String!
    $nonce: String
    $paymentMethodToken: String
    $storeInVault: Boolean
    $referringGameId: Int
    $awinAffiliateInfo: JSON
    $tikTokEventApiAffiliateInfo: JSON
  ) {
    completeOrderV2(
      id: $orderId
      payAmount: $payAmount
      timeZone: $timeZone
      paymentMethodNonce: $nonce
      paymentMethodToken: $paymentMethodToken
      storeInVaultOnSuccess: $storeInVault
      referringGameId: $referringGameId
      awinAffiliateInfo: $awinAffiliateInfo
      tikTokEventApiAffiliateInfo: $tikTokEventApiAffiliateInfo
    ) {
      ...OrderFragment

      orderItems {
        id

        ... on GameOrderItem {
          showPartnerOffer
        }
      }
    }
  }

  ${orderFragment}
`;

export function useCompleteOrder({ orderId, timeZone }) {
  const [mutate] = useMutation(query);
  const completeOrder = ({
    payAmount,
    nonce,
    // Alternative to `nonce` - pays with an already-saved card (a
    // CreditCard's own token) directly, with no Hosted Fields/Drop-in
    // tokenize() step at all. Exactly one of the two should be passed;
    // the mutation itself rejects both/neither.
    paymentMethodToken,
    referringGameId,
    storeInVault,
    awinAffiliateInfo,
    tikTokEventApiAffiliateInfo,
  }) =>
    mutate({
      variables: {
        awinAffiliateInfo,
        tikTokEventApiAffiliateInfo,
        orderId,
        payAmount,
        timeZone,
        nonce,
        paymentMethodToken,
        storeInVault,
        referringGameId,
      },
    });

  return { completeOrder };
}
